import axios from "axios";

export function configurationsAPI(merchant_id, domain) {
  const params = {};
  if (merchant_id) params.mid = merchant_id;
  if (domain) params.sd = domain;

  return axios.get(
    `${process.env.REACT_APP_API_DOMAIN}/api/site-widget/modal/config/`,
    { params }
  );
}

// export function domainConfigurationAPI(domain) {
//   return axios.get(
//     `https://n8n.solidwebhook.com/webhook/site_widget_settings?sd=${domain}`
//   );
// }

export function searchOrders(settings, email, phonenumber, order_name, token) {
  return axios.get(`${settings.rms_api_host}/orders/`, {
    params: {
      phonenumber,
      merchant_id: settings.merchant.id,
      email,
      offset: 0,
      limit: 50,
      order_name,
    },
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export function fetchAllOrders(settings, email, phone, merchant_id, token) {
  if (email && email !== null) {
    return axios.get(
      `${settings.rms_api_host}/orders/?merchant_id=${merchant_id}&email=${email}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  } else if (phone && phone !== null) {
    return axios.get(
      `${settings.rms_api_host}/orders/?merchant_id=${merchant_id}&phonenumber=${phone}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  }
}

export function getMid(settings) {
  return axios.get(
    `${settings.rms_api_host}/get/encrypted/merchant_id?mid=${settings.merchant.id}`
  );
}

export function trackOrderApi(order_id, merchant_id) {
  return axios.get(
    `${process.env.REACT_APP_API_DOMAIN}/api/site-widget/order-tracking/?mid=${merchant_id}&oid=${order_id}`
  );
}

export function getHelpArticles(merchant_id) {
  return axios.get(
    `${process.env.REACT_APP_API_DOMAIN}/api/site-widget/help-center/${merchant_id}/articles/search/`
  );
}

export function generateOTPApi(contact, merchant, otp_settings) {
  return axios.post(
    `${process.env.REACT_APP_AUTH_API_HOST}/api/v1/otp/generate`,
    {
      contact,
      merchant,
      otp_settings,
    }
  );
}

export function verifyOtpApi(contact, merchant_id, otp) {
  return axios.post(
    `${process.env.REACT_APP_AUTH_API_HOST}/api/v1/otp/verify`,
    {
      contact,
      merchant_id,
      otp,
    }
  );
}

export function faqSearch(searchTerm, merchant_id) {
  return axios.get(
    `${process.env.REACT_APP_API_DOMAIN}/api/site-widget/help-center/${merchant_id}/articles/search/`,
    {
      params: {
        q: searchTerm,
      },
    }
  );
}

export function contactUsApi(
  merchant_id,
  full_name,
  email,
  phone_number,
  query_reason,
  message
) {
  return axios.post(
    `${process.env.REACT_APP_API_DOMAIN}/api/site-widget/${merchant_id}/customer-query/`,
    {
      merchant: merchant_id,
      full_name,
      email,
      phone_number,
      query_reason,
      message,
    }
  );
}

export function npsSubmitApi(
  merchant_id,
  order,
  net_promoter_score,
  nps_comment
) {
  return axios.post(
    `${process.env.REACT_APP_API_DOMAIN}/api/merchants/nps/submit/`,
    {
      mid: merchant_id,
      order,
      net_promoter_score,
      nps_comment,
      nps_source: "website",
    }
  );
}
